import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import Text from '../../input_filed/Text';
import Email from '../../input_filed/Email';
import Password from '../../input_filed/Password';
import SingleSelect from '../../input_filed/SingleSelect';
import File from '../../input_filed/File';
import SaveButton from '../../buttons/SaveButton';
import { Col, Form, Row } from 'react-bootstrap';
import { designationListTodo } from '../../../redux/slices/master/designation/DesignationList';
import { departmentListTodo } from '../../../redux/slices/master/department/DepartmentList';
import Loader from '../../loader/Loader';
import { updateUserSchema, userSchema } from './ValidationSchema';
import { toast, ToastContainer } from 'react-toastify';
import { updateUserTodo } from '../../../redux/slices/user/UpdateUser';

const UpdateUserForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [spiner, setSpiner] = useState(false);
    const { state } = useLocation()
    const designationList = useSelector(state => state?.designationList?.data?.data)
    const departmentList = useSelector(state => state?.departmentList?.data?.data)

    const designation_option = designationList?.map(val => (
        { "value": val?._id, "label": val?.name }
    ))

    const department_option = departmentList?.map(val => (
        { "value": val?._id, "label": val?.name }
    ))

    const status_option = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    // const roleList = [
    //     { value: 'admin', label: 'Admin' },
    //     { value: 'engineer', label: 'Engineer' },
    //     { value: 'operator', label: 'Operator' },
    //     { value: 'viewer', label: 'Viewer' },
    // ];


    const initiaValues = {
        id: state._id,
        user_name: state?.name,
        phone_no: state?.phone,
        email: state?.email,
        // password: state?.name,
        // confirm_password: state?.name,
        // role: state?.userRole, // static in submit
        department: state?.department_id,
        designation: state?.designation_id,
        // status: state?.status, // static Active in submit
        profile_image: '',
        role: 'staff', // static userRole
        status: state?.status || '',
        path: 'category', // static path
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: updateUserSchema,

        onSubmit: (values, action) => {
            setSpiner(true)
            dispatch(updateUserTodo(values)).then((res) => add_res(res))

        }
    })

    const add_res = (res) => {
        if (res?.payload?.status == 200) {
            toast.success(res?.payload?.data?.message, { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/user-list')
            }, 1000);
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.messagea?.message, { position: "bottom-right" });
            setSpiner(false);
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
            setSpiner(false);
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }

    useEffect(() => {
        setLoading(true)
        Promise.all([
            dispatch(designationListTodo({ navigate })),
            dispatch(departmentListTodo({ navigate })),
        ]).finally(() => setLoading(false));
    }, [])


    return (
        <>
            <div className='main_layout p-3'>
                <div className='layout_head mb-3'>
                    <h5>Update User</h5>
                </div>
                <hr />
                {
                    loading ?
                        <Loader /> :
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col xl='3'>
                                    <Text label_name='Name' name='user_name' value={values.user_name} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.user_name && touched.user_name && <span className='text-danger form_label'>{errors.user_name}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <Text label_name='Contact No.' name='phone_no' value={values.phone_no} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.phone_no && touched.phone_no && <span className='text-danger form_label'>{errors.phone_no}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <Email label_name='Email' name='email' value={values.email} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.email && touched.email && <span className='text-danger form_label'>{errors.email}</span>}
                                    />
                                </Col>
                                {/* <Col xl='3'>
                                    <Password label_name='Password' name='password' value={values.password} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.password && touched.password && <span className='text-danger form_label'>{errors.password}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <Password label_name='Confirm Password' name='confirm_password' value={values.confirm_password} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.confirm_password && touched.confirm_password && <span className='text-danger form_label'>{errors.confirm_password}</span>}
                                    />
                                </Col> */}
                                {/* Role selection removed; role is static 'staff' */}
                                <Col xl='3'>
                                    <SingleSelect
                                        label_name='Department'
                                        option={department_option}
                                        name='department'
                                        defaultValue={department_option?.find((option) => option.value === values.department)}
                                        onChange={(e) => setFieldValue('department', e.value)}
                                        onBlur={handleBlur}
                                        error={errors.department && touched.department && <span className='text-danger form_label'>{errors.department}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <SingleSelect
                                        label_name='Designation'
                                        option={designation_option}
                                        name='designation'
                                        onChange={(e) => setFieldValue('designation', e.value)}
                                        defaultValue={designation_option?.find((option) => option.value === values.designation)}
                                        onBlur={handleBlur}
                                        error={errors.designation && touched.designation && <span className='text-danger form_label'>{errors.designation}</span>}
                                    />
                                </Col>
                                {/* Status selection removed; status is static 'Active' */}

                                <Col xl='3'>
                                    <File label_name='Profile Image' name='profile_image'
                                        onChange={(e) => setFieldValue('profile_image', e.currentTarget.files[0])}
                                        onBlur={handleBlur}
                                        error={errors.profile_image && touched.profile_image && <span className='text-danger form_label'>{errors.profile_image}</span>}
                                    />
                                </Col>
                                <div className='col-md-3'>
                                    <SingleSelect
                                        label_name='Status'
                                        option={status_option}
                                        name='status'
                                        onChange={(e) => setFieldValue('status', e.value)}
                                        onBlur={handleBlur}
                                        defaultValue={status_option?.find((option) => option.value === values.status)}
                                        error={errors.status && touched.status && <span className='text-danger form_label'>{errors.status}</span>}
                                    />
                                </div>
                                <Col xl='12' className='d-flex justify-content-end'>
                                    <SaveButton name={'SAVE'} spiner={spiner} />
                                </Col>
                            </Row>
                        </Form>}

            </div>
        </>
    );
};

export default UpdateUserForm;
